
/* NMW Exclusive Accordion */
(function() {
  function initExclusiveAccordions() {
    var accordions = document.querySelectorAll('accordion-disclosure details');
    if (accordions.length < 2) return;

    accordions.forEach(function(d) {
      if (d._nmwToggle) return;
      d._nmwToggle = true;
      d.addEventListener('toggle', function() {
        if (d.open) {
          accordions.forEach(function(o) {
            if (o !== d && o.open) {
              o.removeAttribute('open');
              o.setAttribute('aria-expanded', 'false');
            }
          });
        }
      });
    });
  }

  // Wait for page + theme components to fully load
  window.addEventListener('load', function() {
    setTimeout(initExclusiveAccordions, 500);
  });

  // Also handle Shopify AJAX navigation
  document.addEventListener('shopify:section:load', function() {
    setTimeout(initExclusiveAccordions, 500);
  });

  // MutationObserver as fallback — catches dynamically added accordions
  var observer = new MutationObserver(function() {
    var accordions = document.querySelectorAll('accordion-disclosure details');
    if (accordions.length >= 2) {
      initExclusiveAccordions();
    }
  });
  observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
